import type {WorkspaceUiConfigConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceUiConfigConfiguration";
import {workspaceUiConfigConfigurationValidator} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceUiConfigConfiguration";
import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type WorkspaceUiConfig = {
    configuration: WorkspaceUiConfigConfiguration;
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    id: Uuid;
    revisionId: Uuid;
    status: WorkspaceUiConfigStatus;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    workspaceId: Uuid;
};

export type WorkspaceUiConfigCudLog = WorkspaceUiConfig;

export enum WorkspaceUiConfigStatus {
    disabled = "f62b9462-d992-4df5-b776-888b94dc443c",
    enabled = "4268bd1e-fbae-466b-95fc-5aafcee6ea06",
}

export const workspaceUiConfigValidator = zod.object({
    configuration: workspaceUiConfigConfigurationValidator,
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    id: uuidZodValidator,
    revisionId: uuidZodValidator,
    status: zod.enum(WorkspaceUiConfigStatus),
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    workspaceId: uuidZodValidator,
}) satisfies zod.ZodType<WorkspaceUiConfig>;
